import { Collapse, Text, useBoolean, VStack } from '@chakra-ui/react'
import { useFormContext } from 'react-hook-form'
import { FormPhoneNumberInput } from 'src/components/common/Forms/FormPhoneNumberInput'
import { FormTextarea } from 'src/components/common/Forms/FormTextarea'
import { FormTextInput } from 'src/components/common/Forms/FormTextInput'
import { FormZipCodeInput } from 'src/components/common/Forms/FormZipCodeInput'
import { VFlex } from 'src/components/common/VFlex'
import { SERVICE_NAME } from 'src/constants'
import { useInvoices } from 'src/hooks/invoice/useInvoices'
import { InvoiceFormInputs } from '../InvoiceEditForm'
import InvoiceEditorSection from '../InvoiceEditorSection'
import { LogoUploadDropZone } from './LogoUploadDropZone'

const InvoiceUserInformation = () => {
  const { setValue, watch } = useFormContext<InvoiceFormInputs>()
  const [isShowAll, { toggle: toggleIsShowAll }] = useBoolean(false)
  const { postImagesSeal, postImagesLogo } = useInvoices()
  const logoUrl = watch('company.logo_url')
  const sealUrl = watch('company.seal_url')

  return (
    <InvoiceEditorSection title="あなたの情報" number={5}>
      <VFlex gap="16px">
        <FormTextInput<InvoiceFormInputs>
          label="氏名"
          name="company.user_name"
          isRequired
          w="320px"
          placeholder="例）山田 太郎"
        />
        <FormTextarea<InvoiceFormInputs>
          lineHeight="1.5"
          label="振込先口座"
          name="company.transfer_account"
          isRequired
          placeholder={`例）${SERVICE_NAME}銀行
普通預金 ◯◯支店
00000000`}
          rows={3}
          cols={18}
          w="420px"
        />
      </VFlex>

      <Collapse in={isShowAll}>
        <VStack spacing="16px" align="stretch" mt="20px">
          <FormTextInput<InvoiceFormInputs>
            label="会社名 / 屋号"
            name="company.name"
            w="320px"
            placeholder="例）株式会社Example"
          />
          <FormTextInput<InvoiceFormInputs>
            label="部署名"
            name="company.department_name"
            w="320px"
            placeholder="例）経営企画部"
          />
          <FormTextInput<InvoiceFormInputs>
            label="登録番号"
            name="company.registration_number"
            w="320px"
            placeholder="例）T0000000000000"
            helpTooltipText="インボイス制度で税務署長の登録を受けた番号です（T+13桁の数字）"
          />
          <FormZipCodeInput<InvoiceFormInputs>
            label="郵便番号"
            name="company.zip_code"
            w="160px"
          />
          <FormTextInput<InvoiceFormInputs>
            label="住所"
            name="company.address"
            w="320px"
            placeholder="例）◯◯県△△市□□町 1-2-3 ゼイワンビル10F"
          />
          <FormPhoneNumberInput<InvoiceFormInputs>
            label="TEL"
            name="company.tel"
            placeholder="例）03-0000-0000"
            w="160px"
          />
          <FormTextInput<InvoiceFormInputs>
            label="Mail"
            name="company.email"
            w="320px"
            placeholder="sample@example.co.jp"
          />

          <LogoUploadDropZone
            label="ロゴ"
            imageUrl={logoUrl}
            onDelete={() => {
              setValue('company.logo_url', '')
            }}
            onUpload={async (file) => {
              const url = await postImagesLogo(file)
              setValue('company.logo_url', url)
            }}
          />
          <LogoUploadDropZone
            label="印鑑"
            imageUrl={sealUrl}
            onDelete={() => {
              setValue('company.seal_url', '')
            }}
            onUpload={async (file) => {
              const url = await postImagesSeal(file)
              setValue('company.seal_url', url)
            }}
          />
        </VStack>
      </Collapse>
      <Text
        mt="16px"
        display="inline-block"
        color="primary.purple"
        textDecoration="underline"
        fontSize="12px"
        lineHeight={1}
        fontWeight={700}
        cursor="pointer"
        onClick={toggleIsShowAll}
      >
        {isShowAll ? '詳細情報を隠す' : '詳細情報を表示'}
      </Text>
    </InvoiceEditorSection>
  )
}

export default InvoiceUserInformation
